<template>
  <div class="p-16 bg-surface-tertiary">
    <div aria-hidden="true" class="flex flex-col">
      <p class="heading-xs text-text-on-highlight">{{ directPrice }} kr</p>
      <p class="body-bold-sm text-text-on-highlight">
        och
        {{ monthlyPrice }}
        <span>{{ regularCurrencyUnitString }}</span>
      </p>
    </div>

    <div class="sr-only flex flex-col">
      <p>
        {{ directPrice }} kronor direktbetalning, och {{ monthlyPrice }}
        {{ screenReaderCurrencyUnitString }}
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  cardData?: ProductCard;
}

const props = defineProps<Props>();

const directPrice = computed(() => props.cardData?.payment.DownPayment);
const monthlyPrice = computed(
  () => props.cardData?.bundlePrice?.Plan?.MonthlyFee,
);
const regularCurrencyUnitString = 'kr/mån';
const screenReaderCurrencyUnitString = 'kronor i månaden';
</script>
